import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: -1,
  agenda: [],
  agendaAll: [],
  slideLanguages: {},
  showingId: "start",
  openBBHC: false,
  openTTTQM: false,
  roomName: null,
  thumbImgs: [],
  imgIdx: null,
  refreshMdt: false,
  activeTQM: false,
  checkin_members: [],
  formMember: [],
  checkApprove: null,
  tabType: null,
};

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    increment: state => {
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    updateValue: (state, action) => {
      state.value = action.payload;
    },
    setShowingId: (state, action) => {
      state.showingId = action.payload;
    },
    setAgenda: (state, action) => {
      state.agenda = action.payload || [];
    },
    setAgendaAll: (state, action) => {
      state.agendaAll = action.payload || [];
    },
    setSlideLanguage: (state, action) => {
      const { slideId, lang } = action.payload || {};
      if (!slideId || !lang) return;
      state.slideLanguages[slideId] = lang;
    },
    filterAgenda: (state, action) => {
      state.agenda = [];
      state.thumbImgs = [];
      state.agenda.push(action.payload);
      if (state.agenda[0]?.image_url_1) {
        state.thumbImgs.push({
          name: state.agenda[0]?.image_name_1,
          src: state.agenda[0]?.image_url_1,
        });
      }
      if (state.agenda[0]?.image_url_2) {
        state.thumbImgs.push({
          name: state.agenda[0]?.image_name_2,
          src: state.agenda[0]?.image_url_2,
        });
      }
      if (state.agenda[0]?.image_url_3) {
        state.thumbImgs.push({
          name: state.agenda[0]?.image_name_3,
          src: state.agenda[0]?.image_url_3,
        });
      }
      if (state.agenda[0]?.image_url_4) {
        state.thumbImgs.push({
          name: state.agenda[0]?.image_name_4,
          src: state.agenda[0]?.image_url_4,
        });
      }
      if (state.agenda[0]?.image_url_5) {
        state.thumbImgs.push({
          name: state.agenda[0]?.image_name_5,
          src: state.agenda[0]?.image_url_5,
        });
      }
    },
    resetCount: (state, action) => {
      state.value = action.payload;
    },
    handleOpenBBHC: state => {
      state.openBBHC = !state.openBBHC;
    },
    handleOpenTTTQM: state => {
      state.openTTTQM = !state.openTTTQM;
    },
    setRoomName: (state, action) => {
      state.roomName = action.payload;
    },
    resetAll: () => {
      return initialState;
    },
    setImgIdx: (state, action) => {
      state.imgIdx = action.payload;
    },
    setRefreshMdt: (state, action) => {
      state.refreshMdt = action.payload;
    },
    setActiveTQM: (state, action) => {
      state.activeTQM = action.payload;
    },
    setCheckinMember: (state, action) => {
      state.checkin_members = action.payload;
    },
    setMember: (state, action) => {
      state.formMember = action.payload;
    },
    setCheckApprove: (state, action) => {
      state.checkApprove = action.payload;
    },
    setType: (state, action) => {
      state.tabType = action.payload;
    },
  },
});

export const {
  increment,
  decrement,
  setAgenda,
  setAgendaAll,
  setSlideLanguage,
  filterAgenda,
  updateValue,
  resetCount,
  setShowingId,
  handleOpenBBHC,
  handleOpenTTTQM,
  setRoomName,
  resetAll,
  setImgIdx,
  setRefreshMdt,
  setActiveTQM,
  setCheckinMember,
  setMember,
  setCheckApprove,
  setType,
} = counterSlice.actions;

export default counterSlice.reducer;
